<div class="d-flex align-items-center justify-content-between">
	<div class="d-flex align-items-center ps-3">
		@if (variant) {
			<img
				[src]="iconPath"
				alt=""
				class="dialog-icon"
			/>
		}

		<span
			mat-dialog-title
			class="dialog-title m-0 fw-bold fs-4 {{ variant }}"
			[class.p-0]="!variant"
		>
			{{ title | translate }}
		</span>
	</div>
	<button
		type="button"
		class="close-x"
		(click)="close()"
	></button>
</div>
